import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DialogContent, Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import constants
import { IS_MOBILE } from "../../../../constants/breakpoints";
import BASE_URL from "../../../../constants/baseUrls";

//import general components
import BaseDialog from "../../../common/base-dialog/base-dialog";
import BaseCarousel from "../../../common/base-carousel/base-carousel";

//import images and icons
import Icon from "../../../common/base-icon/icon";

//import styles
import "./description.scss";

function Description({ open, setOpen, description, locationtInformation, previousLocation }) {
    //general variables
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //close modal
    const handleClose = () => {
        setOpen(false);
        navigate(-1);
        searchParams.delete("action");
        setSearchParams(searchParams);
    };

    return (
        <BaseDialog
            title={locale === "en" ? locationtInformation?.english_name : locationtInformation?.name}
            open={open}
            handleClose={handleClose}
            maxWidth="lg"
            top="0"
            icon="close"
        >
            <DialogContent dividers={true}>
                <Grid container item xs={12} rowGap={1} justifyContent="space-between" alignItems="flex-start">
                    <Grid container item xs={12} md={4.25} alignItems="center">
                        <BaseCarousel
                            imageList={locationtInformation?.images}
                            dir="rtl"
                            height={IS_MOBILE ? "220px" : "350px"}
                            slidesPerView={1}
                            spaceBetween={10}
                            loop={true}
                            navigation={true}
                            pagination={true}
                            paginationType="bullets"
                            grid={1}
                            thumbsGallery={false}
                            baseUrl={BASE_URL}
                        />
                    </Grid>

                    <Grid container item xs={12} md={7.5} rowGap={4} alignItems="flex-start">
                        <Grid container item xs={12} justifyContent={{ md: "flex-end" }} alignItems="center">
                            <span className="description__category">
                                {locale === "en" ? locationtInformation?.english_category : locationtInformation?.category}
                            </span>
                        </Grid>

                        <Grid container item xs={12} alignItems="center">
                            <p className="description__text">
                                <span>{t("description")}: </span>
                                {locale === "en" ? locationtInformation?.english_text : locationtInformation?.text}
                            </p>
                        </Grid>

                        <Grid container item xs={12} rowGap={2} justifyContent="space-between" alignItems="stretch">
                            <Grid className="description__points" container item xs={12} md={5.75} direction="column">
                                <span className="description__points-title">{t("points")}:</span>
                                {description?.for_kids ? (
                                    "-"
                                ) : (
                                    <span className="description__warning">
                                        <Icon name="WarningIcon" />
                                        {t("itineraryMessage1")}
                                    </span>
                                )}
                                {description?.has_dedicated_restaurant ? (
                                    <span className="description__has-restaurant">
                                        <Icon name="Food4Icon" />
                                        {t("itineraryMessage2")}
                                    </span>
                                ) : (
                                    ""
                                )}
                            </Grid>

                            <Divider orientation="vertical" flexItem sx={{ borderBottomColor: "var(--teal-color-18)" }} />

                            <Grid container item xs={12} md={5.75} rowGap={2}>
                                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                    <span>
                                        {t("start")}: {description?.start_time.substr(0, 2) + ":" + description?.start_time.substr(2, 2)}
                                    </span>
                                    <Divider width="45%" />
                                    <span>
                                        {t("end")}: {description?.end_time.substr(0, 2) + ":" + description?.end_time.substr(2, 2)}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </BaseDialog>
    );
}

export default Description;
